import { barChart } from './_barChart';
import { lineChart } from './_lineChart';

export function registerLineChart() {
    const chartBlocks = document.querySelectorAll('.price-chart-component.line-chart');
    chartBlocks.forEach((chartBlock) => {
        const type = 'canaryPrices' + chartBlock.dataset.chartType.replace(/-/g, '');
        const data = window[type];
        if (chartBlock.classList) lineChart(chartBlock, data);
    });
}

export function registerBarChart() {
    const chartBlocks = document.querySelectorAll('.price-chart-component.bar-chart');
    chartBlocks.forEach((chartBlock) => {
        const type = 'canaryPrices' + chartBlock.dataset.chartType.replace(/-/g, '');
        const data = window[type];
        if (chartBlock.classList) barChart(chartBlock, data);
    });
}
